import { computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { RASTRO_FEATURE } from './feature';

export function useRastroEnabled() {
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  return computed(() =>
    Boolean(
      isFeatureEnabledonAccount.value(currentAccountId.value, RASTRO_FEATURE)
    )
  );
}

export function useRastroRouteGuard() {
  const router = useRouter();
  const route = useRoute();
  const getAccount = useMapGetter('accounts/getAccount');
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const isRastroEnabled = useRastroEnabled();

  const accountReady = computed(() =>
    Boolean(getAccount.value(currentAccountId.value)?.id)
  );
  const pageReady = computed(
    () => accountReady.value && isRastroEnabled.value
  );

  watch(
    [accountReady, isRastroEnabled],
    () => {
      if (!accountReady.value || isRastroEnabled.value) return;

      router.replace({
        name: 'home',
        params: { accountId: route.params.accountId },
      });
    },
    { immediate: true }
  );

  return { pageReady };
}
